import { AUTOPAUSE_CUTOFF_DAYS_V2, AUTOPAUSE_CUTTOFF_DAYS } from '@/constants';

const getAutoPauseCutoffDays = (isV2Enabled: boolean) =>
  isV2Enabled ? AUTOPAUSE_CUTOFF_DAYS_V2 : AUTOPAUSE_CUTTOFF_DAYS;

export default getAutoPauseCutoffDays;
